import { render } from "./remuneration.vue?vue&type=template&id=33bbd6b5"
import script from "./remuneration.vue?vue&type=script&lang=js"
export * from "./remuneration.vue?vue&type=script&lang=js"

import exportComponent from "/var/jenkins_home/workspace/edu-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__